export const displayServingsText = ({ displayUnit, servings }) => {
  const adjustedServings = parseInt(servingsMultiplier(displayUnit.increment) * servings);
  return `${adjustedServings} ${
    adjustedServings === 1 ? displayUnit.singular : displayUnit.plural
  }`;
};

export const displayPrice = ({ displayUnit, price }) =>
  priceMultiplier(displayUnit.increment) * price;

const servingsMultiplier = increment => Number(increment) / 2;
const priceMultiplier = increment => 2 / Number(increment);
